import { ReactComponent as ReportIcon } from "components/icons/DangerTriangle.svg";
import { ReactComponent as HideIcon } from "components/icons/eye.svg";
import { ReactComponent as AddIcon } from "components/icons/FolderAdd2.svg";
import { ReactComponent as ShareIcon } from "components/icons/share-red.svg";
import { ReactComponent as CollectionIcon } from "components/icons/bookmark.svg";
import { ReactComponent as ManageIcon } from "components/icons/manage_icon.svg";
import { ReactComponent as GearIcon } from "components/icons/gear.svg";
import { Roles } from "components/dialogs/EditNichesDialog/hooks";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMoreMenuData = ({ actions, currentUser, gif, isNicheContentModerator }: any) => {
  const {
    handleHideGif,
    handleManageClick,
    toggleCollection,
    toggleReport,
    toggleShareMenu,
    handleOpenEditNichesDialog,
    toggleGifPrefs,
    toggleNiche,
  } = actions;

  const isAuth = !!currentUser;
  const isCM = !!currentUser?.isContentManager();
  const isThisUserGif = isAuth && gif.userName === currentUser?.username;

  return [
    {
      groupName: null,
      groupMobileName: null,
      items: [
        {
          icon: ShareIcon,
          title: "Share",
          onClick: () => toggleShareMenu(null)
        },
        ...(isAuth ? [{
          icon: AddIcon,
          title: "Add to a niche",
          onClick: toggleNiche
        }] : []),
        ...(isThisUserGif && gif.niches.length > 0 ? [{
          icon: ManageIcon,
          title: "Change niches",
          onClick: () => handleOpenEditNichesDialog(Roles.owner),
        }] : []),
        ...(isAuth && !isThisUserGif && isNicheContentModerator ? [{
          icon: ManageIcon,
          title: "Change niches",
          onClick: () => handleOpenEditNichesDialog(Roles.moderator),
        }] : []),
        ...(isAuth ? [{
          icon: CollectionIcon,
          title: "Add to a collection",
          onClick: toggleCollection
        }] : []),
        {
          icon: ReportIcon,
          title: "Report",
          onClick: toggleReport
        },
        ...(isCM ? [{
          icon: HideIcon,
          title: "Hide",
          onClick: () => handleHideGif(gif)
        }] : []),
        ...(isCM ? [{
          icon: GearIcon,
          title: "Change niches",
          onClick: () => handleOpenEditNichesDialog(Roles.admin),
        }] : []),
        ...(isCM ? [{
          icon: GearIcon,
          title: "Type",
          onClick: toggleGifPrefs,
        }] : []),
        ...(isThisUserGif ? [{
          icon: ManageIcon,
          title: "Manage",
          onClick: () => handleManageClick(gif),
        }] : []),
      ]
    }
  ];
};
